<script>
	// From Lucide
	import { SquarePen } from 'lucide-svelte';

	export let iconClass = '';
</script>

<SquarePen class={iconClass} />
